export const TECH_CHIPS = [
  { label: "React", icon: "fa-brands fa-react" },
  { label: "Python", icon: "fa-brands fa-python" },
  { label: "AI", icon: "fa-solid fa-brain" },
  { label: "iOS", icon: "fa-brands fa-apple" },
  { label: "Integrations", icon: "fa-solid fa-plug" },
  { label: "Kotlin", icon: "fa-brands fa-android" },
];
